import React from "react";
import styled from "styled-components";

import { getSize } from "@racepointenergy/gatsby-theme-sitespark/src/components/Theme/utils";

import OpenBrochure from "images/resource-images/open_brochure.png";
import QuoteRequestImage from "images/resource-images/quote_request_form.png";
import CompanionModuleDual20 from "images/resource-images/dual_20_amp_relay_companion_module.png";
import CompanionModule240v from "images/resource-images/240v_ac_relay_companion_module.png";
import StandaloneEnergyMonitor from "images/resource-images/sav_standalone_energy_monitor.png";
import PBCImage from "images/resource-images/sav_pbc.png";

import RacepointBrochure from "files/SP_BROCHURE_1.1_logo.pdf";
import CompanionModule240vSpecs from "files/SP-240-v-ac-2-pole-relay-companion-module.pdf";
import CompanionModuleSpecs from "files/SP-dual-20-amp-relay-companion-module.pdf";
import PBCSpecs from "files/SP-panel-bridge-controller-spec-sheet.pdf";
import QuoteForm from "files/SP_intake_form_4.0.pdf";
import SEMSpecs from "files/SP-stand-alone-energy-monitor-spec-sheet.pdf";

import { Resources as ResourcesHero } from "./components/resources";
import { ResourceItem } from "./components/ResourceItem";

const Content = styled.ul`
  list-style: none;
  margin: 0;
  padding: 15px 40px;
  @media screen and (min-width: ${getSize("mobile480")}) {
    padding: 30px 40px;
  }
  @media screen and (min-width: ${getSize("tablet720")}) {
    padding: 60px 40px;
  }
  @media screen and (min-width: ${getSize("tablet960")}) {
    display: inline-grid;
    grid-template-columns: 400px 400px;
    grid-column-gap: 30px;
  }
  @media screen and (min-width: ${getSize("desktop1920")}) {
    grid-template-columns: 400px 400px 400px;
  }
`;

export function Resources(props) {
  return (
    <div>
      <ResourcesHero />
      <div style={{ textAlign: "center" }}>
        <Content>
          <ResourceItem
            title="Savant Power Brochure"
            image={OpenBrochure}
            file={RacepointBrochure}
          />
          <ResourceItem
            title="Savant Power Quote Request Form"
            image={QuoteRequestImage}
            file={QuoteForm}
          />
          <ResourceItem
            title="Savant Power Dual 20 Amp Relay Companion Module"
            image={CompanionModuleDual20}
            file={CompanionModuleSpecs}
          />
          <ResourceItem
            title="Savant Power 240V AC (2 Pole) Relay Companion Module"
            image={CompanionModule240v}
            file={CompanionModule240vSpecs}
          />
          <ResourceItem
            title="Savant Stand Alone Energy Monitor Spec Sheet"
            image={StandaloneEnergyMonitor}
            file={SEMSpecs}
          />
          <ResourceItem
            title="Savant Panel Bridge Controller Spec Sheet"
            image={PBCImage}
            file={PBCSpecs}
          />
        </Content>
      </div>
    </div>
  );
}
